import Field from 'components/Form/Field';
import FormHeader from 'components/Form/FormHeader';
import KeyValue from 'components/Layout/KeyValue';
import Link from 'components/Link';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import Notification from 'components/Notification';
import SectionHeader from 'components/SectionHeader';
import Value from 'components/Value';
import useMessage from 'hooks/useMessage';
import {useState} from 'react';
import {useBackend} from 'state/backend';
import {jt, t} from 'ttag';
import {Backend} from 'types/api';

import {TRNDocumentTypes} from '../types';

export type TRNDBackendDataView = Backend<TRNDocumentTypes, 'canEdit'>;

const View = () => {
    const {appPermissions, data} = useBackend<TRNDBackendDataView>();

    const {successMessage} = useMessage<'successMessage'>();

    const [showNotification, setShowNotification] = useState(!!successMessage);

    const link = (
        <Link
            href={window.Urls.partner_item_view()}
        >{t`Your Company page.`}</Link>
    );
    const subTitle = jt`To register or change your Tax Registration Number in MakeLeaps, visit the ${link}`;

    return (
        <div>
            {showNotification && (
                <Notification
                    className="mb-4"
                    onClick={() => setShowNotification(false)}
                    size="sm"
                    type="success"
                >
                    {successMessage}
                </Notification>
            )}
            <NavigationTabs.DocumentSettings selection="taxRegistrationNumber" />
            <FormHeader
                link={{
                    disabled: !appPermissions.canEdit.allowed,
                    href: window.Urls.react_tax_registration_number_edit(),
                    icon: 'edit',
                    kind: 'secondary',
                    label: t`Edit`,
                }}
                subtitle={t`The Document Types that will show your Tax Registration Number (TRN). Only affects MakeLeaps stock document templates.`}
                title={t`TRN Display`}
                tooltipMessage={appPermissions.canEdit.failureReason}
            />
            <div>
                <SectionHeader
                    level={2}
                    subtitle={subTitle}
                    title={t`Your Company TRN`}
                />
                <KeyValue className="mt-4" keyWidth={8}>
                    {data.partnerTrnSettings.map((documentType) => (
                        <Field
                            key={documentType.documentType}
                            label={documentType.label}
                            type="value"
                        >
                            <Value
                                value={{
                                    type: 'boolean',
                                    value: documentType.enabled,
                                }}
                            />
                        </Field>
                    ))}
                </KeyValue>
            </div>
            <div className="mt-12">
                <SectionHeader
                    level={2}
                    subtitle={t`Clients' TRNs can be edited from the Clients' Summary pages.`}
                    title={t`Client TRN`}
                />
                <KeyValue className="mt-4" keyWidth={8}>
                    {data.clientTrnSettings.map((documentType) => (
                        <Field
                            key={documentType.documentType}
                            label={documentType.label}
                            type="value"
                        >
                            <Value
                                value={{
                                    type: 'boolean',
                                    value: documentType.enabled,
                                }}
                            />
                        </Field>
                    ))}
                </KeyValue>
            </div>
        </div>
    );
};

export default View;
